// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PaymentCardLogo_paymentCard_graphql = require("../../../__generated__/PaymentCardLogo_paymentCard_graphql.bs.js");

var convertFragment = PaymentCardLogo_paymentCard_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PaymentCardLogo_paymentCard_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PaymentCardLogo_paymentCard_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PaymentCardLogo_paymentCard_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PaymentCardLogo_paymentCard_graphql.node, convertFragment, fRef);
}

var CardFragment_cardBrandV5_decode = PaymentCardLogo_paymentCard_graphql.Utils.cardBrandV5_decode;

var CardFragment_cardBrandV5_fromString = PaymentCardLogo_paymentCard_graphql.Utils.cardBrandV5_fromString;

var CardFragment = {
  cardBrandV5_decode: CardFragment_cardBrandV5_decode,
  cardBrandV5_fromString: CardFragment_cardBrandV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var amex = (require('../../../../assets/images/amex.svg'));

var discover = (require('../../../../assets/images/discover.svg'));

var mastercard = (require('../../../../assets/images/mastercard.svg'));

var visa = (require('../../../../assets/images/visa.svg'));

var Logos = {
  amex: amex,
  discover: discover,
  mastercard: mastercard,
  visa: visa
};

function PaymentCardLogo(props) {
  var match = use(props.card);
  var brand = match.brand;
  var logo;
  if (brand === "MASTERCARD" || brand === "DISCOVER" || brand === "AMERICAN_EXPRESS" || brand === "VISA") {
    switch (brand) {
      case "AMERICAN_EXPRESS" :
          logo = amex;
          break;
      case "DISCOVER" :
          logo = discover;
          break;
      case "MASTERCARD" :
          logo = mastercard;
          break;
      case "VISA" :
          logo = visa;
          break;
      
    }
  } else {
    logo = visa;
  }
  var brandStr;
  if (brand === "MASTERCARD" || brand === "DISCOVER" || brand === "AMERICAN_EXPRESS" || brand === "VISA") {
    switch (brand) {
      case "AMERICAN_EXPRESS" :
          brandStr = "American Express";
          break;
      case "DISCOVER" :
          brandStr = "Discover";
          break;
      case "MASTERCARD" :
          brandStr = "Mastercard";
          break;
      case "VISA" :
          brandStr = "Visa";
          break;
      
    }
  } else {
    brandStr = "Unknown";
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("img", {
                    className: "block",
                    title: brandStr,
                    alt: brandStr + " logo",
                    src: logo
                  }),
              className: TailwindMerge.twMerge([
                    "border border-gray-200 rounded-md bg-gradient-to-b from-white to-gray-100",
                    Core__Option.getOr(props.className, "")
                  ])
            });
}

var make = PaymentCardLogo;

exports.CardFragment = CardFragment;
exports.Logos = Logos;
exports.make = make;
/* amex Not a pure module */
